import { Pipe, PipeTransform } from '@angular/core';
import { HealthAnalysisJourneyStepEnum } from '../../../../module/health-analysis/journey/enum/health-analysis-journey-step.enum';

@Pipe({name: 'HealthAnalysisStep'})
export class HealthAnalysisStepPipe implements PipeTransform {
    public transform(status: HealthAnalysisJourneyStepEnum, isForPrescriber = false): string {
        switch (status) {
            case HealthAnalysisJourneyStepEnum.IN_STOCK: return (!isForPrescriber) ? 'No Estoque' : 'Aguardando Envio'
            case HealthAnalysisJourneyStepEnum.COLLECTED: return 'Coletado'
            case HealthAnalysisJourneyStepEnum.RECEIVED: return (!isForPrescriber) ? 'No Laboratório' : 'Aguardando Processamento'
            case HealthAnalysisJourneyStepEnum.SENT: return (!isForPrescriber) ? 'Enviado' : 'Enviado'
            case HealthAnalysisJourneyStepEnum.PROCESSING_IN_LABORATORY: return 'Em processamento'
            case HealthAnalysisJourneyStepEnum.BIOINFORMATIC: return (!isForPrescriber) ? 'Bioinformática' : 'Em processamento'
            case HealthAnalysisJourneyStepEnum.RECOLLECTED: return 'Recoleta'
            default: return (!isForPrescriber) ? 'Finalizado' : 'Aguardando Liberação';
        }
    }
}
